"use strict";
/*
 * Created on 12. 2. 2019
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var PriceChangeReportDTO_1 = require("../model/PriceChangeReportDTO");

var PriceChangeReportDTOConverter_1 = require("./PriceChangeReportDTOConverter");

var PriceChangeReportPricesDTOConverter_1 = require("./PriceChangeReportPricesDTOConverter");
/**
 * @author SKu
 */


var PriceChangeReportDTOConverterImpl =
/*#__PURE__*/
function (_PriceChangeReportDTO) {
  _inherits(PriceChangeReportDTOConverterImpl, _PriceChangeReportDTO);

  function PriceChangeReportDTOConverterImpl(priceChangeReportPricesDTOConverter) {
    var _this;

    _classCallCheck(this, PriceChangeReportDTOConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PriceChangeReportDTOConverterImpl).call(this));
    _this.priceChangeReportPricesDTOConverter = priceChangeReportPricesDTOConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(PriceChangeReportDTOConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      return new PriceChangeReportDTO_1.PriceChangeReportDTO(PriceChangeReportDTO_1.PriceChangeReportDTO.schema.releaseName.valueOf(source.releaseName), PriceChangeReportDTO_1.PriceChangeReportDTO.schema.productInfo.valueOf(source.productInfo), conversions.asObjectList(source, 'prices', function (doc) {
        return _this2.priceChangeReportPricesDTOConverter.toObject(doc, conversions);
      }), source.approvedBy ? PriceChangeReportDTO_1.PriceChangeReportDTO.schema.approvedBy.valueOf(source.approvedBy) : null, source.approveDate ? PriceChangeReportDTO_1.PriceChangeReportDTO.schema.approveDate.valueOf(conversions.toDate(source.approveDate)) : null);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this3 = this;

      var result = {
        releaseName: source.releaseName,
        productInfo: source.productInfo,
        prices: conversions.asObjectArray(source, 'prices', function (price) {
          return _this3.priceChangeReportPricesDTOConverter.toDocument(price, conversions);
        }),
        approvedBy: source.approvedBy,
        approveDate: source.approveDate ? conversions.fromDate(source.approveDate) : null
      };
      return result;
    }
  }]);

  return PriceChangeReportDTOConverterImpl;
}(PriceChangeReportDTOConverter_1.PriceChangeReportDTOConverter);

PriceChangeReportDTOConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [PriceChangeReportPricesDTOConverter_1.PriceChangeReportPricesDTOConverter])], PriceChangeReportDTOConverterImpl);
exports.PriceChangeReportDTOConverterImpl = PriceChangeReportDTOConverterImpl;